import { useEffect, useState } from "react";
import { FileDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, downloadFile, errMsg } from "@/lib/api";

export function PdfPreviewDialog({ previewUrl, pdfUrl, title, fileName, onClose }) {
  const [pages, setPages] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get(previewUrl).then((r) => setPages(r.data.pages)).catch((e) => setErr(errMsg(e)));
  }, [previewUrl]);
  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-4xl w-[95vw] h-[90vh] flex flex-col" data-testid="pdf-preview-dialog">
        <DialogHeader className="flex-row flex-wrap items-center justify-between gap-2 pr-8">
          <DialogTitle>{title}</DialogTitle>
          <Button size="sm" variant="outline" onClick={() => downloadFile(pdfUrl, fileName)} data-testid="pdf-preview-download-btn"><FileDown className="h-4 w-4 mr-1" />Download PDF</Button>
        </DialogHeader>
        {err && <div className="text-sm text-red-600" data-testid="pdf-preview-error">{err}</div>}
        {!pages && !err && <div className="flex-1 grid place-items-center text-sm text-slate-500" data-testid="pdf-preview-loading">Preparing preview…</div>}
        {pages && (
          <div className="flex-1 overflow-y-auto rounded bg-slate-200 p-3 space-y-3" data-testid="pdf-preview-pages">
            {pages.map((src, i) => <img key={src.slice(-40)} src={src} alt={`Page ${i + 1}`} className="mx-auto w-full max-w-[794px] bg-white shadow" data-testid={`pdf-preview-page-${i + 1}`} />)}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
